<template>
  <div>
    <div class="top clearfix">
      <div class="home">
        <a
          href="http://www.drcnet.com.cn/www/int/"
          target="_blank"
          class="logo fl"
        ></a>
        <div class="line fl"></div>
        <router-link :to="{ path: '/' }" class="title fl"
          >国研视点数据库</router-link
        >
        <div class="fr">
          <ul class="clearfix">
            <li class="fr">
              <router-link :to="{ path: '/introduce' }" class="introduce"
                >产品与服务</router-link
              >
            </li>
            <li class="fr" v-show="isShowName == false">
              <router-link :to="{ path: '/login' }">登录</router-link>
            </li>
            <li class="fr" v-show="isShowName">
              <a href="javascript:;">{{ "欢迎您，" + userName }}</a>
              <a
                href="javascript:;"
                @click="loginOut"
                style="border-left: 1px solid #c3dbef"
                >退出</a
              >
            </li>
          </ul>
          <search :url="url" />
        </div>
      </div>
    </div>
    <div class="menu">
      <ul class="home clearfix">
        <li>
          <router-link
            :to="{ path: '/list' }"
            :class="{
              menu_hover:
                currentUrl === 'list' &&
                currentId === undefined &&
                currentIdName === undefined,
            }"
            class="first"
            >首页</router-link
          >
        </li>
        <li>
          <router-link
            :to="{ path: '/list', query: { uid: '02' } }"
            :class="{ menu_hover: currentId === '02' }"
            >全部文章</router-link
          >
        </li>
        <li>
          <router-link
            :to="{ path: '/list', query: { uid: '0201', uidname: '专家视点' } }"
            :class="{ menu_hover: currentId === '0201' }"
            >专家视点</router-link
          >
        </li>
        <li>
          <router-link
            :to="{ path: '/list', query: { uid: '0204', uidname: '研究报告' } }"
            :class="{ menu_hover: currentId === '0204' }"
            >研究报告</router-link
          >
        </li>
        <!-- <li>
          <router-link
            :to="{path:'/list',query:{uid:'0203',uidname:'调研报告'}}"
            :class="{menu_hover:currentId === '0203'}"
          >调研报告</router-link>
        </li> -->
        <li>
          <router-link
            :to="{ path: '/column' }"
            :class="{ menu_hover: currentUrl === 'column' }"
            >专家专栏</router-link
          >
          <ul class="children">
            <li>
              <router-link
                :to="{
                  path: '/expert',
                  query: { name: '田辉', id: '02050102' },
                }"
                >漫步金保街</router-link
              >
            </li>
            <li>
              <router-link
                :to="{
                  path: '/expert',
                  query: { name: '周宏春', id: '02050201' },
                }"
                >可持续发展</router-link
              >
            </li>
            <li>
              <router-link
                :to="{
                  path: '/expert',
                  query: { name: '田辉', id: '02050101' },
                }"
                >新冠疫情启示录</router-link
              >
            </li>
          </ul>
        </li>
        <li>
          <router-link
            :to="{ path: '/subject'}"
            :class="{ menu_hover: currentUrl === 'subject' }"
            >特别专题</router-link
          >
          <ul class="children">
            <li>
              <router-link
                :to="{ path: '/subject', query: { uid: '020701', uidname: '与改革同行'} }"
                :class="{ menu_hover: currentId === '0203' }"
                >与改革同行</router-link
              >
            </li>
            <li>
              <router-link
                :to="{ path: '/subject', query: { uid: '020702', uidname: '中国改革开放和伟大复兴史论'} }"
                :class="{ menu_hover: currentId === '0203' }"
                >中国改革开放和伟大复兴史论</router-link
              >
            </li>
          </ul>
        </li>
        <li>
          <router-link
            :to="{ path: '/visibility' }"
            :class="{ menu_hover: currentUrl === 'visibility' }"
            class="visibility"
            >可视化</router-link
          >
        </li>
        <li class="fr time">{{ time }}</li>
      </ul>
    </div>
  </div>
</template>

<script>
import search from "@/components/search";
import { getName, removeName, getToken, removeToken } from "@/require/auth";
export default {
  data() {
    return {
      url: [
        "http://s1.drcnet.com.cn/search/SearchAC.aspx?chnId=1002&fields=",
        "",
      ],
      isShowName: false,
      userName: "",
      time: "",
      currentId: undefined,
      currentUrl: "",
      currentIdName: undefined,
    };
  },
  components: {
    search,
  },
  created() {
    this.currentUrl = this.$route.name;
    for (let key in this.$route.query) {
      if (key.toLowerCase() === "uid") {
        this.currentId = this.$route.query[key];
      } else if (key.toLowerCase() === "uidname") {
        this.currentIdName = this.$route.query[key];
      }
    }
    this.loadTime();
  },
  mounted() {
    if (getToken() !== null && getName() !== null) {
      this.isShowName = true;
      this.userName = getName();
    } else {
      this.isShowName = false;
    }
  },
  methods: {
    // 获取时间
    async loadTime() {
      const { code, data } = await this.$api.get(
        "NewViewSecondController/viewpoint/getSecondNavBarTime"
      );
      if (code === 0) {
        this.time = data;
      }
    },
    async deleteToken() {
      await this.$api.get("DrcnetViewPointController/viewpoint/deleteToken", {
        token: getToken(),
      });
    },
    async deleteGuidToken() {
      await this.$api.get("CommonController/common/clientLogout", {
        guid: localStorage.getItem("murmur"),
      });
    },
    // 退出
    loginOut() {
      // 删除token
      this.deleteToken();
      // 删除跟guid绑定的token
      this.deleteGuidToken();
      // 删除cookies
      this.$store.state.count.forEach((ele) => {
        this.$cookies.set(unescape(ele.name), "", -1, "/", "drcnet.com.cn");
      });
      this.$store.state.count = [];

      // 【 强制退出 】
      let loginUrl = `${this.$testBaseURL}/login.ashx`;
      this.$jsonp(loginUrl, { flag: "logoutp", callbackName: "showData" })
        .then(() => {
          removeName();
          removeToken();
          this.isShowName = false;
          this.userName = "";
          this.$router.push({
            path: "/login",
          });
          // 判断本页面是否为首页
          // resolve();
        })
        .catch((err) => {
          err;
        });
    },
  },
  watch: {
    $route() {
      this.currentId = undefined;
      this.currentIdName = undefined;
      this.currentUrl = this.$route.name;
      for (let key in this.$route.query) {
        if (key.toLowerCase() === "uid") {
          this.currentId = this.$route.query[key];
        } else if (key.toLowerCase() === "uidname") {
          this.currentIdName = this.$route.query[key];
        }
      }
    },
  },
};
</script>

<style lang='less' scoped>
.top {
  background: url(../assets/imgs/navbg.png) no-repeat;
  background-size: 100% 100%;
  width: 100%;
  height: 110px;
  .logo {
    background: url(../assets/imgs/logo_home.png) no-repeat;
    height: 38px;
    width: 112px;
    margin-top: 37px;
  }
  .line {
    width: 2px;
    height: 26px;
    background: rgba(0, 0, 0, 0.1);
    margin: 43px 10px 0 10px;
  }
  .title {
    line-height: 110px;
    font-size: 27px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
  }
  ul {
    li {
      line-height: 39px;
      a {
        color: #f0f6fb;
        padding: 0px 10px;
      }
    }
  }
  .introduce {
    color: #f5da45;
    font-size: 15px;
    font-weight: 700;
  }
  .introduce:hover {
    color: #ff3;
  }
}
.menu {
  width: 100%;
  height: 46px;
  background: #134b84;
  li {
    float: left;
    position: relative;
    a {
      font-size: 16px;
      color: #fff;
      line-height: 46px;
    }
    &:hover {
      .children {
        display: block;
      }
    }
  }
  .first {
    padding-right: 30px;
  }
  li:nth-child(7) a {
    border-left: 1px solid #f5da45;
    font-weight: 700;
    color: #f5da45;
  }
  .time {
    float: right;
    font-size: 14px;
    color: #fff;
    line-height: 46px;
  }
  li + li a {
    padding: 0px 30px;
  }
  li:hover > a {
    color: #ff3;
  }
  .menu_hover {
    color: #ff3 !important;
  }
  .children {
    background: rgba(19, 75, 132, 0.9);
    width: 220%;
    padding: 0px 30px;
    position: absolute;
    display: none;
    z-index: 9999;
    li {
      float: none;
      a {
        font-size: 16px;
        color: #fff;
        line-height: 46px;
        padding: 0;
        &:hover {
          color: #f5da45;
        }
      }
    }
    li + li {
      border-top: 1px dashed #fff;
    }
  }
}
</style>